import { useEffect, useState} from "react";
import { useRouter } from "next/router";
 

export default function TopLoader() {
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const router = useRouter();

  useEffect(() => {
    let timer;

    const startLoading = () => {
      setLoading(true);
      setProgress(30); // Start at 30% immediately
      // Simulate progressive loading (until complete or error)
      timer = setInterval(() => {
        setProgress((prev) => {
          if (prev < 90) return prev + 5;
          return prev;
        });
      }, 200);
    };

    const stopLoading = () => {
      setProgress(100);
      clearInterval(timer);
      setTimeout(() => {
        setLoading(false);
        setProgress(0);
      }, 300); // Let the full bar show for a bit
    };

    router.events.on('routeChangeStart', startLoading);
    router.events.on('routeChangeComplete', stopLoading);
    router.events.on('routeChangeError', stopLoading);

    return () => {
      clearInterval(timer);
      router.events.off('routeChangeStart', startLoading);
      router.events.off('routeChangeComplete', stopLoading);
      router.events.off('routeChangeError', stopLoading);
    };
  }, [router]);

  return (
    <>
      {loading && (
        <div className="top-loader" style={{ width: `${progress}%` }} />
      )}
      <style jsx>{`
        .top-loader {
          position: fixed;
          top: 0;
          left: 0;
          height: 10px;
          background-color: #29d;
          z-index: 9999;
          transition: width 0.2s ease, opacity 0.4s ease;
        }
      `}</style>
    </>
  );
}
